<template>
	<!-- Те же файлы, что в шапке и футере лендинга (public/logo). -->
	<img
		class="h-1r w-auto"
		:src="theme === 'light' ? '/logo/logotype-black.svg' : '/logo/logotype-white.svg'"
		alt="Commune"
	/>
</template>

<script setup>
	defineProps({
	  theme: {
    	type: String,
	    default: "light"
    }
	})
</script>
